const translations = {
  en: {
    // Login/Register
    employeePortal: 'Employee Portal',
    loginTitle: 'Login',
    registerTitle: 'New Registration',
    mobileNumber: 'Mobile Number',
    password: 'Password',
    fullName: 'Full Name',
    login: 'Login',
    register: 'Register',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    loginSuccess: 'Login successful!',
    registerSuccess: 'Registration successful!',
    yourId: 'Your Employee ID',
    
    // Expense form
    submitExpense: 'Submit Expense',
    myExpenses: 'My Expenses',
    date: 'Date',
    amount: 'Amount',
    category: 'Category',
    purpose: 'Purpose / Description',
    uploadReceipt: 'Upload Receipt Photo',
    submit: 'Submit',
    submitting: 'Submitting...',
    selectCategory: 'Select category',
    employeeName: 'Employee Name',
    employeeNamePlaceholder: 'Type or pick employee name',
    categoryPlaceholder: 'Type or pick category',
    otherCategory: 'Other (type manually)',
    enterCategory: 'Enter category name',
    pickCategory: 'Please pick a category from the list or choose Other',
    addExpense: 'Add Expense',
    lineNote: 'Note (optional)',
    total: 'Total',
    uploadBills: 'Bill / Photos (for all expenses)',
    pickEmployee: 'Please enter the employee name',
    filesSelected: 'photo(s) selected',
    askAdmin: "No account? Ask your admin to create your login.",
    changePassword: 'Change Password',
    notifyAccounts: 'Tell Accounts on WhatsApp',
    sentToAccounts: 'Sent to Accounts for checking',
    deleteEntry: 'Delete this entry?',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    deleted: 'Entry deleted',
    withAccounts: 'With Accounts',
    verifiedBy: 'Verified by',
    accountsReason: 'Accounts reason',
    withAdmin: 'With Admin',
    myEntries: 'My Entries',
    reviewTab: 'Verify Entries',
    
    // Status
    pending: 'Pending',
    approved: 'Approved',
    partiallyApproved: 'Partially Approved',
    rejected: 'Rejected',
    
    // Employee dashboard
    totalSubmitted: 'Total Submitted',
    totalApproved: 'Total Approved',
    pendingReview: 'Pending Review',
    approvedAmount: 'Approved Amount',
    paidVia: 'Paid via',
    adminNotes: 'Admin Notes',
    paymentDetails: 'Payment Details',
    noExpenses: 'No expenses yet. Submit your first expense above!',
    
    // Language
    language: 'Language',
    changeLanguage: 'Change Language',
  },
  
  hi: {
    employeePortal: 'कर्मचारी पोर्टल',
    loginTitle: 'लॉगिन',
    registerTitle: 'नया पंजीकरण',
    mobileNumber: 'मोबाइल नंबर',
    password: 'पासवर्ड',
    fullName: 'पूरा नाम',
    login: 'लॉगिन करें',
    register: 'पंजीकरण करें',
    noAccount: 'खाता नहीं है?',
    haveAccount: 'पहले से खाता है?',
    loginSuccess: 'लॉगिन सफल!',
    registerSuccess: 'पंजीकरण सफल!',
    yourId: 'आपकी कर्मचारी आईडी',
    
    submitExpense: 'खर्चा जमा करें',
    myExpenses: 'मेरे खर्चे',
    date: 'तारीख',
    amount: 'राशि',
    category: 'श्रेणी',
    purpose: 'कारण / विवरण',
    uploadReceipt: 'रसीद फोटो अपलोड करें',
    submit: 'जमा करें',
    submitting: 'जमा हो रहा है...',
    selectCategory: 'श्रेणी चुनें',
    employeeName: 'कर्मचारी का नाम',
    employeeNamePlaceholder: 'कर्मचारी का नाम लिखें या चुनें',
    categoryPlaceholder: 'श्रेणी लिखें या चुनें',
    otherCategory: 'अन्य (खुद लिखें)',
    enterCategory: 'श्रेणी का नाम लिखें',
    pickCategory: 'सूची से श्रेणी चुनें या अन्य चुनें',
    addExpense: 'खर्चा जोड़ें',
    lineNote: 'नोट (वैकल्पिक)',
    total: 'कुल',
    uploadBills: 'बिल / फोटो (सभी खर्चों के लिए)',
    pickEmployee: 'कृपया कर्मचारी का नाम लिखें',
    filesSelected: 'फोटो चुनी गई',
    askAdmin: 'खाता नहीं है? अपने एडमिन से लॉगिन बनवाएँ।',
    changePassword: 'पासवर्ड बदलें',
    notifyAccounts: 'अकाउंट्स को WhatsApp करें',
    sentToAccounts: 'जाँच के लिए अकाउंट्स को भेजा गया',
    deleteEntry: 'यह एंट्री हटाएँ?',
    cancel: 'रद्द करें',
    delete: 'हटाएँ',
    edit: 'बदलें',
    deleted: 'एंट्री हटा दी गई',
    withAccounts: 'अकाउंट्स के पास',
    verifiedBy: 'जाँचकर्ता',
    accountsReason: 'अकाउंट्स का कारण',
    withAdmin: 'एडमिन के पास',
    myEntries: 'मेरी एंट्री',
    reviewTab: 'एंट्री जाँचें',
    
    pending: 'लंबित',
    approved: 'स्वीकृत',
    partiallyApproved: 'आंशिक स्वीकृत',
    rejected: 'अस्वीकृत',
    
    totalSubmitted: 'कुल जमा',
    totalApproved: 'कुल स्वीकृत',
    pendingReview: 'समीक्षा लंबित',
    approvedAmount: 'स्वीकृत राशि',
    paidVia: 'भुगतान तरीका',
    adminNotes: 'एडमिन नोट्स',
    paymentDetails: 'भुगतान विवरण',
    noExpenses: 'अभी तक कोई खर्चा नहीं। ऊपर से अपना पहला खर्चा जमा करें!',
    
    language: 'भाषा',
    changeLanguage: 'भाषा बदलें',
  },
  
  hinglish: {
    employeePortal: 'Employee Portal',
    loginTitle: 'Login Karein',
    registerTitle: 'Naya Registration',
    mobileNumber: 'Mobile Number',
    password: 'Password',
    fullName: 'Poora Naam',
    login: 'Login Karein',
    register: 'Register Karein',
    noAccount: 'Account nahi hai?',
    haveAccount: 'Pehle se account hai?',
    loginSuccess: 'Login ho gaya!',
    registerSuccess: 'Registration ho gaya!',
    yourId: 'Aapki Employee ID',
    
    submitExpense: 'Kharcha Submit Karein',
    myExpenses: 'Mere Kharche',
    date: 'Date',
    amount: 'Amount (Rashi)',
    category: 'Category',
    purpose: 'Kaam / Description',
    uploadReceipt: 'Receipt Photo Upload Karein',
    submit: 'Submit Karein',
    submitting: 'Submit ho raha hai...',
    selectCategory: 'Category chunein',
    employeeName: 'Employee ka Naam',
    employeeNamePlaceholder: 'Employee ka naam likhein ya chunein',
    categoryPlaceholder: 'Category likhein ya chunein',
    otherCategory: 'Other (khud likhein)',
    enterCategory: 'Category ka naam likhein',
    pickCategory: 'List se category chunein ya Other chunein',
    addExpense: 'Kharcha Jodein',
    lineNote: 'Note (optional)',
    total: 'Total',
    uploadBills: 'Bill / Photo (sab kharchon ke liye)',
    pickEmployee: 'Employee ka naam likhein',
    filesSelected: 'photo chuni gayi',
    askAdmin: 'Account nahi hai? Admin se login banwayein.',
    changePassword: 'Password Badlein',
    notifyAccounts: 'Accounts ko WhatsApp karein',
    sentToAccounts: 'Accounts ko check ke liye bheja gaya',
    deleteEntry: 'Ye entry hatayein?',
    cancel: 'Cancel',
    delete: 'Hatayein',
    edit: 'Edit',
    deleted: 'Entry hata di gayi',
    withAccounts: 'Accounts ke paas',
    verifiedBy: 'Check kiya',
    accountsReason: 'Accounts ka kaaran',
    withAdmin: 'Admin ke paas',
    myEntries: 'Meri Entries',
    reviewTab: 'Entries Check Karein',
    
    pending: 'Pending',
    approved: 'Approved',
    partiallyApproved: 'Partial Approved',
    rejected: 'Rejected',
    
    totalSubmitted: 'Total Submitted',
    totalApproved: 'Total Approved',
    pendingReview: 'Review Pending',
    approvedAmount: 'Approved Amount',
    paidVia: 'Payment Mode',
    adminNotes: 'Admin Notes',
    paymentDetails: 'Payment Details',
    noExpenses: 'Abhi tak koi kharcha nahi. Upar se apna pehla kharcha submit karein!',
    
    language: 'Bhasha',
    changeLanguage: 'Bhasha Badlein',
  }
};

export function t(key, lang = 'en') {
  return translations[lang]?.[key] || translations.en[key] || key;
}

export const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिंदी' },
  { code: 'hinglish', label: 'Hinglish' },
];
